import React from 'react';
import PropTypes from 'prop-types';
import Metrics from '@spotahome/soyuz-metrics';
import { trans } from '@spotahome/soyuz/client';

import { getSortingOptions, getHiddenSortingConfig } from '../utils/sorting';

import './SortBy.scss';

const DEFAULT_OPTIONS = getSortingOptions();

const SortBy = ({ handleSortByChange, orderBy }) => {
  const handleChange = e => {
    Metrics.ga.sendEvent('Search', 'sort-by', e.target.value);
    handleSortByChange(e.target.value);
  };

  const hiddenFilterSort = getHiddenSortingConfig(orderBy);
  const options = [
    ...DEFAULT_OPTIONS.map(option => (
      <option value={option.value} key={option.key}>
        {trans('search.filter_header.sort_by')}: {trans(option.key)}
      </option>
    )),
    ...(hiddenFilterSort
      ? [
          <option value={hiddenFilterSort.value} key={hiddenFilterSort.value}>
            {trans('search.filter_header.sort_by')}:{' '}
            {trans(hiddenFilterSort.key)}
          </option>
        ]
      : [])
  ];

  return (
    <div className={'sort-by'}>
      <select
        className="sort-by__select"
        onChange={handleChange}
        value={orderBy}
      >
        {options}
      </select>
    </div>
  );
};

SortBy.propTypes = {
  handleSortByChange: PropTypes.func.isRequired,
  orderBy: PropTypes.string.isRequired
};

export default SortBy;
